import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z","key":"svg-0"}],["path",{"d":"M15 4l0 16","key":"svg-1"}]]

const IconLayoutSidebarRight = createReactComponent('outline', 'layout-sidebar-right', 'LayoutSidebarRight', __iconNode);

export default IconLayoutSidebarRight;